import { Observable } from 'rxjs';
import { Actions } from '../../actions';
import * as authActionCreators from '../../auth/action-creators';
import * as authActions from '../../auth/actions';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { push } from 'connected-react-router';

export const registrationSuccessEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, authActionCreators.CreateAccountSuccess>(authActions.CREATE_ACCOUNT_SUCCESS),
    map((action) => {
      return push(`/register/verify?account=${encodeURIComponent(action.user.username)}`)
    })
  );